var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpinLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id1: "BXT_SpinLoader",
    "data-name": "SpinLoader",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id1: "nball00",
    "data-name": "Ellipse00",
    cx: 35,
    cy: 35,
    r: 12,
    fill: "#B5B5B5"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 75 75",
    to: "360 75 75",
    begin: "0s",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id1: "nball00",
    "data-name": "Ellipse00",
    cx: 35,
    cy: 35,
    r: 12,
    fill: "#B5B5B5"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 75 75",
    to: "360 75 75",
    begin: "0.5s",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id1: "nball00",
    "data-name": "Ellipse00",
    cx: 35,
    cy: 35,
    r: 12,
    fill: "#B5B5B5"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 75 75",
    to: "360 75 75",
    begin: "1s",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id1: "nball00",
    "data-name": "Ellipse00",
    cx: 35,
    cy: 35,
    r: 12,
    fill: "#B5B5B5"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 75 75",
    to: "360 75 75",
    begin: "1.5s",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id1: "nball00",
    "data-name": "Ellipse00",
    cx: 35,
    cy: 35,
    r: 12,
    fill: "#B5B5B5"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 75 75",
    to: "360 75 75",
    begin: "2s",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id1: "nball00",
    "data-name": "Ellipse00",
    cx: 35,
    cy: 35,
    r: 12,
    fill: "#B5B5B5"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 75 75",
    to: "360 75 75",
    begin: "2.5s",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id1: "nball00",
    "data-name": "Ellipse00",
    cx: 35,
    cy: 35,
    r: 12,
    fill: "#B5B5B5"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 75 75",
    to: "360 75 75",
    begin: "3s",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id1: "nball00",
    "data-name": "Ellipse00",
    cx: 35,
    cy: 35,
    r: 12,
    fill: "#B5B5B5"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 75 75",
    to: "360 75 75",
    begin: "3.5s",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id1: "nball00",
    "data-name": "Ellipse00",
    cx: 35,
    cy: 35,
    r: 12,
    fill: "#B5B5B5"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 75 75",
    to: "360 75 75",
    begin: "4s",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id1: "nball00",
    "data-name": "Ellipse00",
    cx: 35,
    cy: 35,
    r: 12,
    fill: "#B5B5B5"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 75 75",
    to: "360 75 75",
    begin: "4.5s",
    dur: "5s",
    repeatCount: "indefinite"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinLoader);
export default __webpack_public_path__ + "static/media/SpinLoader.843735e605228c39e60b08253bd62b5b.svg";
export { ForwardRef as ReactComponent };